import { useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useStore } from 'react-redux'
import { useQueryClient } from 'react-query'

import { useAppDispatch } from 'app/state'
import { localStorageSupported } from 'app/api/localStorage'

import { setGetTokenFn } from 'features/common'
import { meRequest } from 'features/users/state/usersSlice'

function useAuthentication() {
  const store = useStore()
  const dispatch = useAppDispatch()
  const queryClient = useQueryClient()
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0()
  const [accessToken, setAccessToken] = useState<string>('')
  const e2eToken = localStorageSupported() ? (window.localStorage.getItem('E2E_LOGIN_TOKEN') as string) : null
  const isLoadingE2EAuthentication = e2eToken && !accessToken

  useEffect(() => {
    if (isAuthenticated) {
      const getAccessToken = async () => {
        setAccessToken(await getAccessTokenSilently())
      }
      setGetTokenFn(getAccessTokenSilently, store)
      getAccessToken()
    } else {
      if (e2eToken) {
        // If the token is manually defined, we can use it directly (currently used in e2e tests)
        setGetTokenFn(async () => await e2eToken, store)
        setAccessToken(e2eToken)
      }
    }
  }, [getAccessTokenSilently, e2eToken, isAuthenticated, store])

  useEffect(() => {
    if (accessToken) {
      dispatch(meRequest())
      queryClient.invalidateQueries()
    }
  }, [accessToken, queryClient, dispatch])

  return {
    isAuthenticated: isAuthenticated || !!accessToken,
    isLoading: isLoading || isLoadingE2EAuthentication
  }
}

export default useAuthentication
